// extracted by mini-css-extract-plugin
module.exports = {"ideaWrapContainer":"ideasListWrapper_ideaWrapContainer__1yh3T"};